/* eslint-disable */
class Auth {
    test() {
        alert('test')
        return false
    }
}

export default Auth = new Auth();